// API Base URL Configuration
export const BASE_URL = process.env.REACT_APP_API_URL || 'https://bugrateknikapi.projearkadasim.com';

// Token expired event emitter
let tokenExpiredCallback = null;

export const setTokenExpiredCallback = (callback) => {
  tokenExpiredCallback = callback;
};

export const triggerTokenExpired = () => {
  if (tokenExpiredCallback) {
    tokenExpiredCallback();
  }
};

// Simple API request function with retry mechanism
export const apiRequest = async (endpoint, options = {}, retries = 3) => {
  const url = endpoint.startsWith('http') ? endpoint : `${BASE_URL}${endpoint}`;
  
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  };

  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      const response = await fetch(url, config);
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        
        // Token geçersiz olduğunda otomatik olarak modal göster
        if (response.status === 401 || response.status === 403) {
          triggerTokenExpired();
        }
        
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error(`API Request Error (attempt ${attempt}/${retries}):`, error);
      
      // Network error veya token hatası durumunda da modal göster
      if (error.message.includes('401') || error.message.includes('403') || error.message.includes('No authentication token')) {
        triggerTokenExpired();
      }
      
      // Son deneme ise hatayı fırlat
      if (attempt === retries) {
        throw error;
      }
      
      // Retry için bekle (exponential backoff)
      await new Promise(resolve => setTimeout(resolve, Math.pow(2, attempt) * 1000));
    }
  }
};

// Auth token helper
export const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

export const setAuthToken = (token) => {
  localStorage.setItem('authToken', token);
};

export const removeAuthToken = () => {
  localStorage.removeItem('authToken');
};

// Authenticated request
export const authRequest = async (endpoint, options = {}) => {
  const token = getAuthToken();
  
  if (!token) {
    triggerTokenExpired();
    throw new Error('No authentication token found');
  }
  
  const authOptions = {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  };

  try {
    return await apiRequest(endpoint, authOptions);
  } catch (error) {
    // Token geçersiz olduğunda otomatik olarak modal göster
    if (error.message.includes('401') || error.message.includes('403') || error.message.includes('No authentication token')) {
      triggerTokenExpired();
    }
    throw error;
  }
}; 